import React from 'react';
import Chart from 'react-apexcharts';

const StatusChart = ({ Data,data1 }) => {
    const combinedData = Data.flatMap((recruiter) => {
        const openingStatus = Data?.map((status) => ({
            label: status.job_opening_status,
            count: status.cnt,
        }));

        const recruitData = data1
            .filter((status) => status.status_name === "Recruit")
            .map((status) => ({
                label: status.status_name,
                count: status.cnt,
            }));

        const recruitCount = recruitData[0]?.count || 0;
        const adjustedOpeningStatus = openingStatus?.map((status) => {
            if (status.label === "Open") {
                return {
                    label: status.label,
                    count: status.count - recruitCount,
                };
            }
            return status;
        });
        return [...adjustedOpeningStatus, ...recruitData];
    });
    

    const series = combinedData.map((item) => item.count);
    const labels = combinedData.map((item) => item.label);
    const labelColors = {
        Open: '#FF0000', 
        Recruit: '#008000', 
    };
    const colors = labels.map((label) => labelColors[label] || '#0000FF');

    const chartState = {
        series,
        options: {
            chart: {
                type: 'donut',
                height: 300,
            },
            labels,
            colors,
            dataLabels: {
                enabled: false,
            },
            responsive: [
                {
                    breakpoint: 767,
                    options: {
                        chart: {
                            height: 300,
                        },
                    },
                },
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            height: 400,
                        },
                        legend: {
                            position: 'bottom',
                        },
                    },
                },
            ],
        },
    };

    return (
        
        <Chart options={chartState.options} series={chartState.series} type="donut" height={300} />
    );
};

export default StatusChart;
